<template>
  <div>
    <v-subheader class="subheader">{{label}}</v-subheader>
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      :disabled="disabled"
      @change="onEditorChange($event)"
    ></quill-editor>
  </div>
</template> 
 

<script>
export default {
  props: {
    label: String,
    value: String,
    disabled: Boolean
  },
  data() {
    return {
      editorOption: {}
    };
  },
  computed: {
    content: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit('change',val)
      }
    }
  },
  methods: {
    onEditorChange({ html }) {
      //内容改变事件
      this.content = html;
      
    }
  }
};
</script>

<style>
.ql-editor{
  min-height: 250px;
}
</style>
